import { useEffect, useRef, useState, type FormEvent } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { PageShell } from '../components/PageShell';
import { useAuth } from '../store/authStore';
import { errorMessage } from '../lib/api';
import { toast } from '../store/uiStore';

function useToken(): string { const [p] = useSearchParams(); return p.get('token') ?? ''; }

function ConsumeToken({ title, action, done }: { title: string; action: (token: string) => Promise<unknown>; done: string }) {
  const token = useToken();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return; ran.current = true;
    if (!token) { setError('This link is missing its token.'); return; }
    action(token).then(() => { toast(done); navigate('/'); }).catch((e: unknown) => setError(errorMessage(e)));
  }, [token, action, done, navigate]);
  return (
    <PageShell eyebrow="Account" title={title}>
      {error ? <div className="notice notice--err">{error} <Link to="/auth">Sign in</Link></div> : <div className="hint">One moment…</div>}
    </PageShell>
  );
}

export function ActivateRoute() { const activate = useAuth((s) => s.activate); return <ConsumeToken title="Activating your account" action={activate} done="Welcome to Tonist" />; }
export function MagicRoute() { const consume = useAuth((s) => s.magicConsume); return <ConsumeToken title="Signing you in" action={consume} done="Signed in" />; }

export function ResetRoute() {
  const token = useToken();
  const reset = useAuth((s) => s.reset);
  const navigate = useNavigate();
  const [pw, setPw] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const submit = async (e: FormEvent) => {
    e.preventDefault(); setBusy(true); setError(null);
    try { await reset(token, pw); toast('Password changed — sign in'); navigate('/auth'); } catch (err) { setError(errorMessage(err)); } finally { setBusy(false); }
  };
  return (
    <PageShell eyebrow="Account" title="Choose a new password">
      <form className="glass panel stack" style={{ maxWidth: 420 }} onSubmit={(e) => void submit(e)}>
        {!token && <div className="notice notice--err">This link is missing its token.</div>}
        <div className="field">
          <label htmlFor="reset-pw">New password (10+ characters)</label>
          <input id="reset-pw" className="input" type="password" autoComplete="new-password" required minLength={10} value={pw} onChange={(e) => setPw(e.target.value)} />
        </div>
        {error && <div className="notice notice--err" role="alert">{error}</div>}
        <button type="submit" className="btn btn--primary" disabled={busy || !token}>Set password</button>
      </form>
    </PageShell>
  );
}
